import useResponsive from "@/hooks/useResponsive.hook";
import { RecapKPICardsProps } from "@/interfaces/IRecap";
import { Flex, Typography } from "antd";
import { useTranslation } from "react-i18next";

const { Text, Paragraph } = Typography;

const KPICards = ({ overview }: RecapKPICardsProps) => {
  const { t } = useTranslation();
  const isResponsive = useResponsive();

  return (
    <Flex gap={12} wrap className="recap-kpi-cards-wrapper">
      <Flex
        vertical={isResponsive}
        gap={12}
        className={isResponsive ? "recap-kpi-cards p-4" : "recap-kpi-cards p-5"}
        wrap
      >
        {!isResponsive ? (
          <Flex gap={8} wrap vertical>
            <Text>{t("recap.duration")}</Text>
            <Text className="font-weight-500">
              {overview?.duration?.durationText || "-"}
            </Text>
            <Text type="secondary">
              {overview?.duration?.description || "-"}
            </Text>
          </Flex>
        ) : null}
      </Flex>

      <Flex
        vertical={isResponsive}
        gap={12}
        className={isResponsive ? "recap-kpi-cards p-4" : "recap-kpi-cards p-5"}
        wrap
      >
        <Flex gap={8} wrap vertical>
          <Text>{t("recap.firstJoin")}</Text>

          <Flex align="baseline" wrap>
            <Text className="font-weight-500">
              {overview?.firstJoin?.time || "--:--"}
            </Text>
          </Flex>

          <Text type="secondary">
            {overview?.firstJoin?.description || "-"}
          </Text>
        </Flex>
      </Flex>

      <Flex
        vertical={isResponsive}
        gap={12}
        className={isResponsive ? "recap-kpi-cards p-4" : "recap-kpi-cards p-5"}
        wrap
      >
        <Flex gap={8} wrap vertical>
          <Text>{t("recap.lastLeave")}</Text>

          <Flex align="baseline" wrap>
            <Text className="font-weight-500">
              {overview?.lastLeave?.time || "--:--"}
            </Text>
          </Flex>

          <Text type="secondary">
            {overview?.lastLeave?.description || "-"}
          </Text>
        </Flex>
      </Flex>

      <Flex
        vertical={isResponsive}
        gap={12}
        className={isResponsive ? "recap-kpi-cards p-4" : "recap-kpi-cards p-5"}
        wrap
      >
        {!isResponsive ? (
          <Flex vertical gap={8}>
            <Text>{t("recap.totalAttendance")}</Text>

            <Flex align="baseline" gap={4} wrap>
              <Text className="font-weight-500">
                {overview?.participants?.participantCount || 0}
              </Text>
            </Flex>

            <Text type="secondary">
              {overview?.participants?.description || "-"}
            </Text>
          </Flex>
        ) : null}
      </Flex>

      <Flex
        vertical={isResponsive}
        gap={12}
        className={isResponsive ? "recap-kpi-cards p-4" : "recap-kpi-cards p-5"}
      >
        <Flex gap={8} wrap vertical>
          <Text>{t("recap.engagement")}</Text>

          <Text className="font-weight-500 color-success">
            {overview?.engagement?.percentText || "-"}
          </Text>
          <Paragraph
            ellipsis={{
              rows: 2,
              tooltip: {
                placement: "bottom",
              },
            }}
            type="secondary"
          >
            {t("recap.engagementDescription", {
              speakingParticipants:
                overview?.engagement?.speakingParticipants || 0,
              totalParticipants: overview?.participants?.participantCount || 0,
            })}
          </Paragraph>
        </Flex>
      </Flex>
    </Flex>
  );
};

export default KPICards;
